//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBox from "@/components/SearchBox.vue";
import CipaiRight from "@/components/nav_cipai/CipaiRight.vue";
import Market from "@/components/Market.vue";
import authorData from "./authorFujianData.json";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      title: "词牌 - 中华诗词库",
      description: "词牌 - 中华诗词库",
      keyword: "",
      authorData: authorData
    };
  },

  metaInfo() {
    return {
      title: this.title,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },

  components: {
    SearchBox,
    CipaiRight,
    Market
  },

  methods: {
    search: function() {
      if (this.keyword == "") {
        return;
      }

      this.$router.push({ name: "search", query: { q: this.keyword } });
    },

    ...mapActions(["loadBanner"])
  },

  beforeCreate() {
    this.$initWechat().then(() => {
      this.$initWechatShare({
        title: this.title,
        link: location.href,
        image: "http://bigfile.xichuangzhu.com/logo.png",
        desc: this.description
      });
    });
  },

  created() {
    this.loadBanner();
  },

  computed: {
    ...mapGetters(["banner"])
  }
};



// WEBPACK FOOTER //
// ./src/pages/layouts/jm-pages/Fujian.vue